import React, { useState } from "react";
import { Button } from "react-bootstrap";
import i18n from "../../../../utils/ChrI18n.js";
import CookieSection from './CookieSection.jsx';

import { cookieTypes } from "./data.js";
import CookieUtils from "../../../../interfaces/CookieUtils.js";
import { setCookieAndHandleTracking } from "../utils.js";

const commonButtonClasses = "btn btn-md b-r-xs-important cui-cookie-consent-button-mobile-height ml-0";

const getDefaultCookieValue = (cookieValue) => {
  return cookieValue === "false";
}

const CustomizeCookiePreferences = ({ hideModal, setIsVisible, data }) => {

  let cookieConsentObject = CookieUtils.getSafelyParsedCookieValue(data.consentConstants.cookieNames.cookieConsent);
  const [cookiesData, setCookiesData] = useState(cookieTypes.map(item => {
    return item.isEditable ? { ...item, enabled: cookieConsentObject?.[item.key] ?? getDefaultCookieValue(CookieUtils.getCookie(data.consentConstants.cookieNames.showOptInConsentBanner)) } : item;
  }));

  const handleButtonClick = (eventActionName, cookieValue, cookiesData = null) => {
    setCookieAndHandleTracking(data, eventActionName, cookieValue, cookiesData);
    hideModal();
    setIsVisible?.(false);
    const cookieConsentPopupElement = document.getElementById("cjs-cookie-consent-popup");
    cookieConsentPopupElement && cookieConsentPopupElement.classList.add("hide");
  }

  return (
    <>
      <div>
        {`${i18n.t("feature.cookie_consent.content.cookies_modal_info_text")} `}
        <span dangerouslySetInnerHTML={{__html: i18n.t("feature.cookie_consent.content.cookies_modal_info_text_policy_link_html", { 'cookiePolicyUrl': data.cookiePolicyUrl })}}>
        </span>
      </div>
      <div className="d-flex flex-column gap-4 pt-4">
        {cookiesData.map((cookieData, idx) =>
          <CookieSection cookieData={cookieData} key={idx} setCookiesData={setCookiesData} />
        )}
      </div>
      <div className="d-flex flex-xs-row flex-column justify-content-end pt-6 pb-1 gap-2">
        <Button bsClass={`${commonButtonClasses} border-interactive text-primary`} onClick={() => handleButtonClick(chrEventConstants.action.CLICKED_REJECT_ALL_COOKIES, false)}>{i18n.t("feature.cookie_consent.button.Reject_All")}</Button>
        <Button bsClass={`${commonButtonClasses} border-interactive text-primary`} onClick={() => handleButtonClick(chrEventConstants.action.CLICKED_ACCEPT_ALL_COOKIES, true)}>{i18n.t("feature.cookie_consent.button.Accept_All")}</Button>
        <Button bsClass={`${commonButtonClasses} border-interactive bg-accent text-primary-on-dark`} onClick={() => handleButtonClick(chrEventConstants.action.CLICKED_SAVE_COOKIE_PREFERENCES, null, cookiesData)}>{i18n.t("feature.cookie_consent.button.Save_My_Preferences")}</Button>
      </div>
    </>
  );
}

export default CustomizeCookiePreferences;
